import React from 'react';
import Image from '@react/shared/Image';
const EventCard = ({ title, content, image, url, dates, pinText }) => (React.createElement("div", { className: "grid-column" },
    React.createElement("a", { href: url, className: "card card--event " },
        React.createElement("div", { className: "card__inner" },
            React.createElement("div", { className: "card__media" },
                React.createElement("div", { className: "card__media-holder" },
                    React.createElement(Image, { image: image, alt: title, width: 460, className: "card__media-element", cdn: true }))),
            React.createElement("div", { className: "card__content-external" },
                React.createElement("div", { className: "tag tag--green" }, pinText),
                React.createElement("div", { className: "card__content-internal" },
                    React.createElement("h4", { className: "card__title" }, title),
                    React.createElement("div", { className: "card__intro" }, content),
                    React.createElement("div", { className: "card__event-date-area" },
                        React.createElement("p", { className: "card__event-date" }, dates))))))));
export default EventCard;
